interface IconHeartOptions {
    cssClasses? : string
}

export function IconHeart(props : IconHeartOptions) {
    return (
        <svg id="a4c00abb-0406-4b94-8424-ccda65a9fc9b" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.83 19" className={props?.cssClasses}>
            <path className="f0d0e689-eedd-4f94-8f8b-d1a52cc28f9b" d="M14.17.83A5.08,5.08,0,0,0,10,3.08,5.08,5.08,0,0,0,5.83.83a5,5,0,0,0-5,5c0,5,9.17,12.5,9.17,12.5s9.17-7.5,9.17-12.5A5,5,0,0,0,14.17.83Z" transform="translate(-0.08 -0.08)"/>
            <path className="a68989a5-fea4-4cba-a8af-0365b3c77a04" d="M14.17.83A5.08,5.08,0,0,0,10,3.08,5.08,5.08,0,0,0,5.83.83a5,5,0,0,0-5,5c0,5,9.17,12.5,9.17,12.5s9.17-7.5,9.17-12.5A5,5,0,0,0,14.17.83Z" transform="translate(-0.08 -0.08)"/>
        </svg>
    );
}
